import React from 'react';
import PhoneInput from 'react-phone-input-2';
import 'react-phone-input-2/lib/material.css';
import labelsPL from 'react-phone-input-2/lang/pl.json';
import TextField from '@mui/material/TextField';

export const SmallPhoneNumberField = ({ value, onChange, label, placeholder, error, helperText }) => (
  <PhoneInput
    country="pl"
    countryCodeEditable={false}
    value={value}
    onChange={(val, countryData, e, formattedValue) => {
      const normalized = val.startsWith('+')
        ? val
        : `+${val}`;
      onChange(normalized);
      console.log(normalized);
    }}
    containerStyle={{ width: '60%', maxWidth: '1200px' }}
    inputStyle={{ width: '100%', height: '40px', fontSize: '0.875rem' }}
    localization={labelsPL}
    inputComponent={props => (
      <TextField
        {...props}
        label={label}
        placeholder={placeholder}
        variant="outlined"
        error={error}
        helperText={helperText}
        onChange={e => props.onChange(e.target.value)} // 🔹 wymagane dla MUI
      />
    )}
  />
);
